/**
 * Enum to hold comparators for all search select fields
 */
export enum HisSelectComparatorType {
    NE = 'ne', //not equal
    EQ = 'eq' //equal

}
